<template>
  <div>
    <div v-if="$redirectToPatientAppFlag" class="max-width">
      <Alert>
        <a :href="PATIENT_APP_URL" class="link">
          The Ciitizen patient portal has moved to a new address. <u>Click here</u> to be redirected
          to log in. Or access our login at any time from the ciitizen website at www.ciitizen.com.
        </a>
      </Alert>
    </div>
    <div v-else class="login-wrapper">
      <div class="right-side-wrapper">
        <div class="right-side">
          <v-form ref="form" @submit.prevent="onSubmit">
            <v-text-field
              v-model="form.email"
              label="Email"
              :error="$v.form.email.$error"
              required
              type="text"
            />
            <v-text-field
              v-model="form.password"
              type="password"
              label="Password"
              :error="$v.form.password.$error"
              :error-messages="`${
                $v.form.password.$error
                  ? 'Must include an uppercase, a lowercase, and a number'
                  : ''
              }`"
              required
            />
            <v-btn
              ref="btn-submit"
              depressed
              color="#128279"
              class="btn-styling center-button"
              shaped
              height="40px"
              max-height="44px"
              type="submit"
            >
              Register
            </v-btn>
            <div class="login-link" @click="$router.push({ name: 'login' })">Login</div>
          </v-form>
        </div>
      </div>
    </div>
    <progress-loader v-if="loading" id="progress-loader" />
  </div>
</template>

<script>
import { DEFAULT_INVITE_TOKEN, onBoardingLink, onboardingUrl, PATIENT_APP_URL } from 'config'
import { mapActions, mapState } from 'vuex'
import { email, minLength, required } from 'vuelidate/lib/validators'
import { Utils } from '@ciitizen/component-library'
import Alert from '../components/alert'

export default {
  name: 'Register',
  mounted() {
    if (this.$redirectToPatientAppFlag && !window.location.href.includes('hie-access')) {
      setTimeout(() => {
        window.location.href = PATIENT_APP_URL
      }, 10000)
    } else if (window.location.href.includes('hie-access')) {
      window.location.href = `${onboardingUrl}/hie/cures_gateway`
    }
  },
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      timeout: 3000,
      loading: false,
      errorMessage: '',
      snackbar: false,
      onBoardingLink,
      isSuccess: false,
      PATIENT_APP_URL
    }
  },
  validations: {
    form: {
      email: { required, email },
      password: {
        required,
        minLength: minLength(8),
        containsUppercase: function (value) {
          return /[A-Z]/.test(value)
        },
        containsLowercase: function (value) {
          return /[a-z]/.test(value)
        },
        containsNumber: function (value) {
          return /[0-9]/.test(value)
        }
      }
    }
  },
  computed: {
    ...mapState({
      userId: state => state.login.userId
    }),
    year() {
      const date = new Date()
      return date.getFullYear()
    },
    inviteToken() {
      return this.$route.query.tkn || DEFAULT_INVITE_TOKEN
    }
  },
  methods: {
    ...mapActions([
      'login',
      'registerUser',
      'updateUserProfile',
      'createCaregiverPatient',
      'createUser'
    ]),
    async onSubmit() {
      this.$v.$touch()
      if (this.$v.form.$error) return
      try {
        this.loading = true
        const payload = {
          email: this.form.email.toLowerCase().trim(),
          password: this.form.password,
          inviteToken: this.inviteToken,
          type: 'regular'
        }
        let response = await this.createUser(payload)
        Utils.callSegmentTrack({ name: 'ob.create_account.clicked' })
        Utils.callSegmentTrack({ name: 'ob.user_name.saved' })
        Utils.callSegmentIdentify({
          createdAt: new Date(),
          email: this.form.email,
          uuid: response.userId
        })
        Utils.callSegmentTrack({ name: 'pp.login.success' })
        this.$router.push(`/${this.userId}/home`)
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    }
  },
  components: { Alert }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.center-button
  display: flex
  margin: 0 auto
.login-wrapper
  display: flex
  height: 90%
  justify-content: center
  align-items: center

.right-side
  width: 100%

.btn-styling
  color: white
  font-weight: 700
  outline: none !important
  margin-top: 30px
  text-transform: capitalize
  font-size: 18px

.sign-up-wrapper
  display: flex
  margin-top: 30px
  justify-content: center

.sign-up-styling
  font-style: normal
  font-weight: 400
  font-size: 16px
  line-height: 19px
  color: #185ABC
  margin-left: 5px

.no-account-styling
  font-style: normal
  font-weight: normal
  font-size: 16px
  line-height: 19px
  color: #4F4F4F

.right-side-wrapper
  display: block
  width: 300px

.form-container
  display: flex
  flex-direction: column

.hyperlink-style
  text-decoration: none
  color: #80868B
.login-link
  font-style: normal
  font-weight: 400
  font-size: 16px
  line-height: 17px
  color: #828282
  margin-top: 15px
  display:flex
  width : 100%
  justify-content: center
  cursor: pointer

/* Handling medium sized screens */
@media only screen and (max-width: 769px)
  .login-wrapper
    padding: 0 40px
  .right-side-wrapper
    display: block

/* For mobile screens */
@media only screen and (max-width: 561px)
  .login-wrapper
    display: flex
    flex-direction: column
    justify-content: flex-start
    padding: 24px
  .btn-styling
    width: 100%
  .right-side
    width: 325px
    padding-top: 40px
  .right-side-wrapper
    display: contents

.max-width
  width: 325px
</style>
